import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { VisaLogo } from 'app/shared/components/atoms';
import { Box, Typography } from 'app/shared/components/atoms';

interface Props {
  onPresale: boolean;
  eventIsVisaEligible: boolean;
  canRedeemVisaFreeTicket: boolean;
  visaFreeTicketRedeemedForEvent: boolean;
  cardType?: string;
}

export const VisaDisclaimer: React.FC<React.PropsWithChildren<Props>> = ({
  onPresale,
  eventIsVisaEligible,
  canRedeemVisaFreeTicket,
  visaFreeTicketRedeemedForEvent,
  cardType,
}) => {
  const intl = useIntl();
  const theme = useCurrentTheme();

  function visaFreeBonusTicketIntlKey() {
    if (!eventIsVisaEligible) {
      return 'event.eventCTA.concertIsNotVisaEligible';
    }
    if (canRedeemVisaFreeTicket) {
      return 'event.eventCTA.oneFreeVisaTicket';
    }
    if (visaFreeTicketRedeemedForEvent) {
      return 'event.eventCTA.ticketRedeedemedForThisEvent';
    }
    return 'event.eventCTA.freeVisaTicketsUsed';
  }

  const visaYellow = '#F7B600';

  function visaCopyColor() {
    if (!eventIsVisaEligible) {
      return theme.colors.messaging.error.dark;
    }

    return theme.colors.primary.black.base;
  }

  // FYI We no longer want to display booking fee copy on Visa disclaimer
  return (
    <Box
      pt={[0, 6, 6, 6]}
      pb={6}
      flexDirection="column"
      gap={2}
      backgroundColor={theme.colors.primary.white.base}
      p={8}
      my={4}
    >
      {(onPresale || canRedeemVisaFreeTicket) && (
        <Box
          data-qaid="event-page-cta-widget-visa-title"
          alignItems="center"
          gap={2}
        >
          <VisaLogo h="16px" />
          <Box
            backgroundColor={visaYellow}
            borderRadius="100px"
            px={3}
            py={2}
            w="fit-content"
            alignItems="center"
            display="grid"
          >
            <Typography
              fontSize="fontSize25"
              fontWeight="medium"
              textTransform="uppercase"
              lineHeight="8px"
            >
              {intl.formatMessage({
                id: 'event.eventCTA.visaBenefitActivated',
              })}
            </Typography>
          </Box>
        </Box>
      )}
      <Typography color={visaCopyColor()} fontSize="fontSize100">
        {intl.formatMessage(
          {
            id: visaFreeBonusTicketIntlKey(),
          },
          {
            cardType,
          }
        )}
      </Typography>
    </Box>
  );
};
